module.exports = __webpack_public_path__ + "static/media/SVGmoneyControl.a47bfb99.svg";